import { UPDATE_CURRENT_PAGE } from 'components/Pagelayout/actions';
import { PageState } from 'models/PageState';
import { EventDefinition, EventMap } from './event';

const updateTitle = (prevTitle: string, nextTitle: string) =>
  prevTitle !== nextTitle && ((document.querySelector('title') || { text: '' }).text = nextTitle);

const attributeMap: { [key: string]: string[] } = {
  meta: ['name', 'content'],
  link: ['rel', 'href']
};

const updateNodes = (element: string) => (tags: { [key: string]: string }) => {
  Array.from(document.querySelectorAll(`${element}[data-page]`)).forEach(
    n => document.head && document.head.removeChild(n)
  );
  tags &&
    Object.keys(tags).forEach(key => {
      const node = document.createElement(element);
      node.setAttribute('data-page', '');
      node.setAttribute(attributeMap[element][0], key);
      node.setAttribute(attributeMap[element][1], tags[key]);
      document.head && document.head.appendChild(node);
    });
};

const updateTags = updateNodes('meta');
const updateLinks = updateNodes('link');

const updateMetaData: EventDefinition<PageState, void> = (
  _action,
  { currentPage: { meta: prev } },
  { currentPage: { meta: next } }
) => {
  updateTitle(prev.title, next.title);
  updateTags(next.tags);
  updateLinks(next.links);
};

export const metaData: EventMap = {
  [UPDATE_CURRENT_PAGE]: updateMetaData
};
